(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["axwell-customer-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('axwell-review-carousel')) {
    customElements.define('axwell-review-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.axwell-customer-reviews__track');
        this.cards = [...this.querySelectorAll('[data-review-card]')];
        this.previous = this.querySelector('[data-previous]');
        this.next = this.querySelector('[data-next]');
        this.position = this.querySelector('[data-position]');
        if (!this.track || !this.cards.length) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.previous.addEventListener('click', () => this.move(-1), options);
        this.next.addEventListener('click', () => this.move(1), options);
        this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          if (event.key === 'Home') this.go(0);
          else if (event.key === 'End') this.go(this.cards.length - 1);
          else this.move(event.key === 'ArrowRight' ? 1 : -1);
        }, options);
        this.addEventListener('shopify:block:select', event => {
          const card = event.target.closest('[data-review-card]');
          if (card) this.go(this.cards.indexOf(card), true);
        }, options);
        const total = this.querySelector('[data-review-total]');
        if (total) total.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en').format(Number(total.dataset.reviewTotal));
        this.resize = new ResizeObserver(() => this.update());
        this.resize.observe(this.track);
        this.update();
      }
      disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); }
      start(card) { return card.offsetLeft - this.cards[0].offsetLeft; }
      go(index, immediate = false) {
        const behavior = immediate || matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        this.track.scrollTo({ left: this.start(this.cards[Math.max(0, Math.min(index, this.cards.length - 1))]), behavior });
      }
      move(direction) {
        const current = this.cards.reduce((best, card, index) => Math.abs(this.start(card) - this.track.scrollLeft) < Math.abs(this.start(this.cards[best]) - this.track.scrollLeft) ? index : best, 0);
        this.go(current + direction);
      }
      update() {
        const left = this.track.scrollLeft, right = left + this.track.clientWidth;
        const shown = this.cards.map((card, index) => ({ card, index })).filter(({card}) => this.start(card) >= left - 4 && this.start(card) + card.offsetWidth <= right + 4);
        this.previous.disabled = left <= 3;
        this.next.disabled = right >= this.track.scrollWidth - 3;
        if (shown.length) {
          const first = shown[0].index + 1, last = shown[shown.length - 1].index + 1;
          this.position.textContent = `${first === last ? first : `${first}–${last}`} ${this.position.dataset.of} ${this.cards.length} ${this.position.dataset.reviews}`;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["axwell-featured-wallets"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('axwell-wallet-strip')) {
    customElements.define('axwell-wallet-strip', class extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        const { signal } = this.abortController;
        const scroller = this.querySelector('scroll-carousel');
        const cards = [...this.querySelectorAll('.axwell-featured-wallets__item')];
        const status = this.querySelector('[data-wallet-status]');
        if (!scroller || !cards.length) return;
        const update = () => {
          const bounds = scroller.getBoundingClientRect();
          const visible = cards.map((card, index) => ({ index, rect: card.getBoundingClientRect() }))
            .filter(({ rect }) => Math.min(rect.right, bounds.right) - Math.max(rect.left, bounds.left) > rect.width * .9);
          if (visible.length) {
            const first = visible[0].index + 1;
            const last = visible[visible.length - 1].index + 1;
            status.textContent = (first === last ? first : first + '–' + last) + ' of ' + cards.length + ' wallets';
          }
        };
        scroller.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(update);
        }, { passive: true, signal });
        scroller.addEventListener('keydown', (event) => {
          if (event.target !== scroller || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const step = cards[1] ? cards[1].offsetLeft - cards[0].offsetLeft : scroller.clientWidth;
          const left = event.key === 'Home' ? 0 : event.key === 'End' ? scroller.scrollWidth : scroller.scrollLeft + (event.key === 'ArrowRight' ? step : -step);
          scroller.scrollTo({ left, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        }, { signal });
        this.observer = new ResizeObserver(update);
        this.observer.observe(scroller);
        update();
      }
      disconnectedCallback() {
        this.abortController?.abort();
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
